export default __webpack_public_path__ + "static/media/background.532e76bb.png";